export default __webpack_public_path__ + "static/Edmondsans-Medium-34983e9cf51741c45895f0bc09e96621.otf";